<template>
    <div class="cabinet-detail-table">
        <div
            v-if="product.Description"
            class="cabinet-detail-table__row"
            v-html="product.Description"
        ></div>
        <div v-else class="cabinet-detail-table__row">Описание отсутствует</div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DetailDescr',
    computed: {
        ...mapState('supplierProducts', ['product'])
    }
}
</script>
